import { useTheme } from '@mui/material';
import { useMemo } from 'react';

const useAssetronHeaderStyles = () => {
  const theme = useTheme();

  const styles = useMemo(
    () => ({
      headerDimensions: {
        width: '100vw',
        height: theme.sizeGuide['8xl'],
        paddingLeft: theme.sizeGuide['8xl'],
        paddingRight: theme.sizeGuide['8xl'],
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
          padding: theme.sizeGuide.none,
        },
      },
      logoPadding: {
        paddingLeft: theme.sizeGuide['4xl'],
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
          paddingLeft: theme.sizeGuide.none,
          justifyContent: 'center',
        },
      },
    }),
    [theme],
  );

  return styles;
};

export default useAssetronHeaderStyles;
